import { useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootReducer } from 'redux/reducers';
import { toggleDsPick } from 'redux/mode/actions';
import { DesignSystemToken } from 'designSystem/types';
import * as S from './styles';

interface WeightScaleProps {
	tokens: DesignSystemToken[];
	dark: boolean;
	primaryFont: string;
}

const getWeight = (token: DesignSystemToken): number => {
	if (token.value.kind === 'fontWeight') return token.value.numeric;
	return 400;
};

const WeightScale = ({ tokens, dark, primaryFont }: WeightScaleProps) => {
	const dispatch = useDispatch();
	const selectedPicks = useSelector((r: RootReducer) => r.mode.selectedDsPicks);

	const sorted = useMemo(() => [...tokens].sort((a, b) => getWeight(a) - getWeight(b)), [tokens]);

	const isSelected = (token: DesignSystemToken) =>
		selectedPicks.some((p) => p.kind === 'token' && p.cssVariable === token.cssVariable);

	if (sorted.length === 0) return null;

	const shortPreview = 'Handgloves';

	return (
		<S.WeightGrid>
			{sorted.map((token) => {
				const w = getWeight(token);
				return (
					<S.WeightItem
						key={token.id}
						type="button"
						$selected={isSelected(token)}
						$dark={dark}
						onClick={() =>
							dispatch(toggleDsPick({ kind: 'token', cssVariable: token.cssVariable }))
						}
					>
						<S.WeightTooltip>{token.cssVariable}</S.WeightTooltip>
						<S.WeightSample $dark={dark} style={{ fontWeight: w, fontFamily: primaryFont }}>
							{shortPreview}
						</S.WeightSample>
						<S.WeightLabel>{token.name}</S.WeightLabel>
						<S.WeightValue>{w}</S.WeightValue>
					</S.WeightItem>
				);
			})}
		</S.WeightGrid>
	);
};

export default WeightScale;
